export default class TypeValue {
  constructor(name, initialValue, namespace, typeValue) {
    this.namespace=namespace;
    this.name=name;
    this.type="@type";
    this.typeValue=typeValue||"";
    this.value="";
    if (initialValue) {
      this.parseInputJSON(initialValue);
    }
  }

  getNameSpace() {
    return this.namespace;
  }

  getValue() {
    return this.value;
  }

  setValue(value) {
    this.value=value;
  }

  getType() {
    return this.typeValue;
  }

  setType(value) {
    this.typeValue=value;
  }

  getExpandedFormatValue() {
    const obj={
      "@value": this.getValue(),
      [this.type]: this.getType(),
    };
    return [obj];
  }

  parseInputJSON(inputJSON) {
    if (!inputJSON||!inputJSON[this.namespace]) {
      return;
    }
    let val=null;
    if (this.namespace) {
      val=inputJSON[this.namespace][0];
    } else {
      val=inputJSON;
    }
    this.setValue(val["@value"]);
    this.setType(val[this.type]);
  }

  isEmpty() {
    return !this.value;
  }
}
